import type HttpClient from "../../tastyworks/http"
import type { SingleResponse } from "../../tastyworks/response"
import {
  TASTYFX_TOKENS_DESER,
  TastyfxTokens,
} from "../../tastyworks/tastyfx-tokens"

export class TastyfxTokensService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly show = async (
    register?: boolean
  ): Promise<SingleResponse<TastyfxTokens>> =>
    this.baseHttpClient.show(
      new TastyfxTokens(),
      TASTYFX_TOKENS_DESER.update,
      "/tastyfx/tokens",
      { register: register ? "true" : undefined }
    )
}
